if (!customElements.get('mathers-predictive')) {
customElements.define('mathers-predictive', class extends HTMLElement {
  connectedCallback() {
    if (this.bound) return;
    this.bound = true;
    this.input = this.querySelector('input[name="q"]');
    this.panel = this.querySelector('.part-suggestions');
    this.status = this.querySelector('[data-search-status]');
    this.input.addEventListener('input', () => {
      clearTimeout(this.timer); this.request?.abort(); this.close();
      const term = this.input.value.trim();
      if (term.length < 2) return;
      this.timer = setTimeout(() => this.search(term), 220);
    });
    this.addEventListener('keydown', e => {
      if (e.key === 'Escape') { this.request?.abort(); clearTimeout(this.timer); this.close(); this.input.focus(); }
      if ((e.key === 'ArrowDown' || e.key === 'ArrowUp') && !this.panel.hidden) {
        const links = [...this.panel.querySelectorAll('a')];
        if (!links.length) return;
        e.preventDefault();
        const i = links.indexOf(document.activeElement);
        links[(i + (e.key === 'ArrowDown' ? 1 : -1) + links.length) % links.length].focus();
      }
    });
    this.addEventListener('focusout', () => setTimeout(() => { if (!this.contains(document.activeElement)) this.close(); }, 0));
    this.input.addEventListener('focus', () => { if (this.panel.textContent && this.lastTerm === this.input.value.trim()) this.open(); });
  }
  close() { this.panel.hidden = true; this.input.setAttribute('aria-expanded', 'false'); }
  open() { this.panel.hidden = false; this.input.setAttribute('aria-expanded', 'true'); }
  async search(term) {
    this.request = new AbortController();
    try {
      const url = new URL(this.dataset.endpoint, location.origin);
      url.searchParams.set('q', term);
      url.searchParams.set('resources[type]', 'product');
      url.searchParams.set('resources[limit]', '6');
      url.searchParams.set('resources[options][fields]', 'title,variants.sku');
      url.searchParams.set('section_id', 'part-suggestions');
      const response = await fetch(url, {signal:this.request.signal});
      if (!response.ok) throw new Error('Search unavailable');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const results = doc.querySelector('[data-suggestion-results]');
      if (!results || term !== this.input.value.trim()) return;
      this.panel.replaceChildren(results); this.lastTerm = term;
      if (this.contains(document.activeElement)) this.open();
      this.status.textContent = `${results.querySelectorAll('.part-suggestion').length} suggested products`;
    } catch (error) { if (error.name !== 'AbortError') { this.close(); this.status.textContent = 'Press Enter to search all products.'; } }
  }
  disconnectedCallback() { clearTimeout(this.timer); this.request?.abort(); }
});
}